var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"item_page_header"},[(!_vm.showNav && _vm.showBackBtn)?_c('div',{staticClass:"header_route"},[_c('span',{staticClass:"route_back",on:{"click":_vm.routeBack}})]):_vm._e(),_c('p',{staticClass:"item_page_title"},[_vm._v(_vm._s(_vm.header_title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }